const { reactive } = require('vue')

const LANGUAGE_STORAGE_KEY = 'anovator-site-language'
const SUPPORTED_LANGUAGES = Object.freeze(['EN', 'ZH'])
const DEFAULT_LANGUAGE = 'EN'

const MESSAGES = Object.freeze({
  EN: Object.freeze({
    'navigation.products': 'Products',
    'navigation.industries': 'Industry Solution',
    'navigation.services': 'Services',
    'navigation.support': 'Support',
    'navigation.about': 'About Us',
    'navigation.contact': 'Contact Us',
    'navigation.administratorPlatform': 'Administrator Platform',
    'navigation.apiDocumentation': 'API Documentation',
    'navigation.primary': 'Primary navigation',
    'navigation.home': 'ANOVATOR home',
    'navigation.toggle': 'Toggle navigation',
    'navigation.contactAria': 'Contact ANOVATOR',
    'navigation.switchSite': 'Switch site',
    'navigation.siteSwitcher': 'Site switcher',
    'navigation.mobile': 'Mobile navigation',
    'navigation.back': 'Back to main navigation',
    'navigation.close': 'Close navigation',
    'navigation.aboutAnovator': 'About ANOVATOR',
    'navigation.newsroom': 'Newsroom',
    'about.subnavAria': 'About page sections',
    'about.subnavTitle': 'About ANOVATOR',
    'about.companyProfile': 'Company Profile',
    'about.corporateCulture': 'Corporate Culture',
    'about.companyHistory': 'Company History',
    'about.navHistory': 'Company Founded',
    'about.qualification': 'Qualification',
    'about.navQualification': 'Qualification',
    'about.profileParagraph1': 'Founded in 2013, ANOVATOR is a Global Pioneer in Medical-Grade Human Data Services. We provide precise, scientific, and intelligent health assessment technologies for healthcare providers and wellness professionals worldwide.',
    'about.profileParagraph2': 'As an integrated company spanning R&D, design, manufacturing, branding, and global sales, ANOVATOR is committed to independent innovation. Backed by a strong portfolio of patents and proprietary technologies, our products deliver internationally recognized medical-grade performance, empowering users with comprehensive solutions from data acquisition to AI-driven clinical insights.',
    'about.profileParagraph3': "Today, ANOVATOR serves customers in more than 50 countries and regions, with its international headquarters located in Dubai. Our products meet the highest global quality standards and are certified by ISO 13485, FDA, MDR, CE, SGS, CICC, and China's Class II Medical Device Registration, ensuring reliable solutions for the global healthcare industry.",
    'about.profileImageAlt': 'ANOVATOR medical-grade human data services',
    'about.iconSuffix': ' icon',
    'about.mission': 'Corporate Mission',
    'about.missionDescription': 'Empowering society with precise, scientific, comprehensive, and accessible human data solutions.',
    'about.vision': 'Corporate Vision',
    'about.visionDescription': 'To become the new infrastructure for the global health industry in the AI era.',
    'about.values': 'Corporate Values',
    'about.valuesDescription': 'Simple & Reliable',
    'about.history2013Event1': 'Company Founded',
    'about.history2016Event1': 'First Health Monitoring Product Launched',
    'about.history2016Event2': 'M Series Medical-Grade Body Composition Analyzer Released',
    'about.history2016Event3': 'Body Data Service Platform Introduced',
    'about.history2019Event1': "K Series Children's Smart Fitness Assessment System Launched",
    'about.history2019Event2': 'A Series All-in-One Health Assessment System Released',
    'about.history2022Event1': 'Global Expansion Initiated',
    'about.history2022Event2': 'Dubai Branch Established',
    'about.history2022Event3': 'Presence in 50+ Countries & Regions',
    'about.history2024Event1': 'FDA, SGS & EMC Certified',
    'about.history2024Event2': '8M+ Registered Users',
    'about.history2024Event3': '500M+ Body Composition Data Records',
    'about.history2026Event1': 'Certified as a Class II Medical Device in China',
    'about.qualificationFda': 'Food and Drug Administration',
    'about.qualificationIso9001': 'ISO13485',
    'about.qualificationRohs': 'ROHS',
    'about.qualificationSgs': 'SGS',
    'about.qualificationCe': 'CE certification',
    'about.qualificationClassII': 'Class II medical device',
    'about.qualificationHighTech': 'High-tech enterprise',
    'about.documentTitle': 'About ANOVATOR - ANOVATOR',
    'contact.title': 'Contact Us',
    'contact.intro': 'If you want to know more about us, please contact us in the following ways, we will serve you wholeheartedly',
    'contact.headOffice': 'Head Office',
    'contact.phone': 'Phone: ',
    'contact.email': 'Email: ',
    'contact.namePlaceholder': 'Your Name',
    'contact.emailPlaceholder': 'Enter Your Email',
    'contact.phonePlaceholder': 'WhatsApp / Phone',
    'contact.messagePlaceholder': 'Write Your Message Here',
    'contact.submit': 'Send Message',
    'contact.submitting': 'Sending...',
    'contact.closeAria': 'Close Contact Us',
    'contact.privacyPrefix': 'I have read and accept the ',
    'contact.privacyLink': 'Privacy Policy',
    'contact.privacySuffix': '.',
    'contact.nameRequired': 'Please enter your name.',
    'contact.emailRequired': 'Please enter your email address.',
    'contact.emailInvalid': 'Please enter a valid email address.',
    'contact.whatsappRequired': 'Please enter your WhatsApp / phone number.',
    'contact.whatsappShort': 'Phone number must be at least 6 characters long.',
    'contact.whatsappInvalid': 'WhatsApp / phone number is invalid.',
    'contact.messageRequired': 'Please enter your message.',
    'contact.privacyRequired': 'Please confirm that you have read and accept the Privacy Policy.',
    'home.learnMore': 'Learn more',
    'home.technologyBefore': 'How Does',
    'home.technologyAfter': "evaluate People's Health",
    'home.technologyParagraph1': 'We uses Multiple Frequencies 8-Point Tactile Electrode System, with two electrodes placed on each hand and each foot. During measurement, the electrodes individually detect impedance data from five body segments: the left arm, right arm, torso, left leg and right leg.',
    'home.technologyParagraph2': 'Compared to traditional BIA measurements, our use of multiple frequencies of alternating current allows for better penetration of body cells and greater resistance to external electromagnetic interference. This enables us to obtain more accurate measurements of body composition.',
    'home.technologyParagraph3': 'We utilize AI image analysis technology to determine the precise location and dimensions of skeletal points, combined with accurate body composition data, such as muscle and fat content in various body parts. This allows us to precisely analyze body posture risks and body circumference measurements.',
    'home.exhibitionTitle': 'Exhibition Schedule',
    'home.exhibitionLead': 'We are looking forward to your visit at the exhibition site!',
    'home.highlightsAria': 'ANOVATOR highlights',
    'home.industriesAria': 'Industries',
    'home.featuredStoriesAria': 'Featured Stories',
    'home.previousStory': 'Previous story',
    'home.nextStory': 'Next story',
    'home.goToSlide': 'Go to slide {{index}}',
    'footer.homeAria': 'ANOVATOR home',
    'footer.contactAria': 'Contact ANOVATOR',
    'footer.socialAria': 'ANOVATOR social media',
    'footer.legalAria': 'Legal links',
    'support.title': 'ANOVATOR Support',
    'support.lead': 'Need help? Start here.',
    'support.selectDevice': 'Please select your device.',
    'support.faq': 'FAQ',
    'support.brochure': 'Brochure',
    'support.manual': 'Manual',
    'support.tutorials': 'Tutorials',
    'support.deviceSeries': 'Device series',
    'support.productDocuments': 'Product documents',
    'support.tutorialsAria': 'Tutorials',
    'support.tutorialControls': 'Tutorial carousel controls',
    'support.previousTutorials': 'Previous tutorials',
    'support.nextTutorials': 'Next tutorials',
    'support.faqCategories': 'FAQ categories',
    'news.latest': 'Latest News',
    'news.more': 'More News',
    'news.viewMore': 'View More',
    'news.newsroom': 'Newsroom',
    'news.all': 'All News',
    'news.loading': 'Loading news...',
    'news.loadingLatest': 'Loading latest news...',
    'news.loadingMore': 'Loading more news...',
    'news.latestUnavailable': 'Latest News Unavailable',
    'news.moreUnavailable': 'More News Unavailable',
    'news.loadingFailed': 'Loading Failed',
    'news.noTop': 'No TOP news is available yet.',
    'news.noMore': 'No more news is available yet.',
    'news.noContent': 'No Content',
    'news.noArticlesInCategory': 'No news articles are available in this category.',
    'news.reload': 'Reload',
    'news.filterLabel': 'Filter news by category',
    'news.allCategories': 'All',
    'news.pagination': 'News pagination',
    'news.previousPage': 'Previous page',
    'news.nextPage': 'Next page',
    'news.goToPage': 'Go to page',
    'news.readArticle': 'Read',
    'news.socialLinks': 'News social links',
    'news.backToList': 'Back to News List',
    'news.notFound': 'News Not Found',
    'news.notFoundDescription': 'The news article you are looking for may have been deleted or does not exist',
    'news.fallbackAuthor': 'The ANOVATOR Team',
    'news.networkTopError': 'Network connection failed. Unable to retrieve TOP news.',
    'news.networkMoreError': 'Network connection failed. Unable to retrieve more news.',
    'news.networkError': 'Network connection failed. Unable to retrieve news. Please check your network connection and try again.',
    'news.invalidUrl': 'Invalid news URL',
    'news.detailNetworkError': 'Network connection failed, please try again later',
    'actions.continueReading': 'Continue Reading',
    'actions.industryLearnMore': 'Learn more',
    'industries.scenarios': 'Applicable Scenarios',
    'industryDetail.recommendations': 'Product Recommendations',
    'industryDetail.loading': 'Loading industry details...',
    'industryDetail.loadError': 'Unable to load industry details. Please try again.',
    'industryDetail.retry': 'Retry',
    'industryDetail.notFound': 'Industry scenario not found',
    'industryDetail.returnToIndustry': 'Return to industry',
    'exhibition.ended': 'Completed',
    'exhibition.ongoing': 'Ongoing',
    'exhibition.upcoming': 'Upcoming',
    'exhibition.carouselControls': 'Exhibition carousel controls',
    'exhibition.previousSlide': 'Previous slide',
    'exhibition.nextSlide': 'Next slide',
    'exhibition.venueSuffix': 'exhibition venue'
  }),
  ZH: Object.freeze({
    'navigation.products': '产品',
    'navigation.industries': '行业解决方案',
    'navigation.services': '服务',
    'navigation.support': '支持',
    'navigation.about': '关于',
    'navigation.contact': '联系我们',
    'navigation.administratorPlatform': '管理平台',
    'navigation.apiDocumentation': '接口文档',
    'navigation.primary': '主导航',
    'navigation.home': 'ANOVATOR 首页',
    'navigation.toggle': '切换导航菜单',
    'navigation.contactAria': '联系 ANOVATOR',
    'navigation.switchSite': '切换站点',
    'navigation.siteSwitcher': '站点切换',
    'navigation.mobile': '移动端导航',
    'navigation.back': '返回主导航',
    'navigation.close': '关闭导航',
    'navigation.aboutAnovator': '关于ANOVATOR',
    'navigation.newsroom': '新闻中心',
    'about.subnavAria': '关于页面章节',
    'about.subnavTitle': '关于ANOVATOR',
    'about.companyProfile': '企业简介',
    'about.corporateCulture': '企业文化',
    'about.companyHistory': '发展历程',
    'about.navHistory': '发展历程',
    'about.qualification': '资质认证',
    'about.navQualification': '资质证书',
    'about.profileParagraph1': '源诺医疗（ANOVATOR）成立于2013年，是全球领先的医疗级人体数据服务商。我们致力于为医疗及其他健康相关行业提供精准、科学、全面、便捷的人体数据服务解决方案。',
    'about.profileParagraph2': '公司集技术研发、设计生产、品牌推广与海内外销售于一体，始终坚持核心技术自主研发，拥有专利、软件著作权等知识产权数十项，旗下多款产品性能达到国际领先医疗水平，为用户提供从数据获取到智能决策的全生命周期管理方案。',
    'about.profileParagraph3': '源诺医疗的业务版图已覆盖全球 50 余个国家与地区，并于迪拜设立海外战略总部。产品凭借卓越的质量控制，成功获得 ISO13485、美国 FDA、欧盟 MDR、CE、SGS、CICC 及中国二类医疗器械注册证等全球权威认证，创建全球健康行业的大基建。',
    'about.profileImageAlt': '源诺医疗（ANOVATOR）医疗级人体数据服务',
    'about.iconSuffix': '图标',
    'about.mission': '企业使命',
    'about.missionDescription': '为社会提供精准、科学、全面、便捷的人体数据服务。',
    'about.vision': '企业愿景',
    'about.visionDescription': '成为AI时代全球健康产业的新基建。',
    'about.values': '企业价值观',
    'about.valuesDescription': '简单可依靠',
    'about.history2013Event1': '公司正式成立',
    'about.history2016Event1': '首代健康监测产品问世',
    'about.history2016Event2': 'M系列-人体成分分析仪正式发布，',
    'about.history2016Event3': '发布身体数据服务平台，并首度在健身行业应用推广',
    'about.history2019Event1': 'K系列-儿童专业智能体测仪正式发布',
    'about.history2019Event2': 'A系列-全能体测仪正式发布，迅速成为市场上最热门的产品之一',
    'about.history2022Event1': '品牌全球化正式启动',
    'about.history2022Event2': '成立迪拜分公司',
    'about.history2022Event3': '业务覆盖50+国家与地区',
    'about.history2024Event1': '通过FDA、SGS、EMC等各项国际专业测试',
    'about.history2024Event2': '截止目前，已有超过800万注册会员',
    'about.history2024Event3': '累积了5亿+条人体成分数据',
    'about.history2026Event1': '获中国二类医疗器械认证',
    'about.qualificationFda': 'FDA认证',
    'about.qualificationIso9001': 'ISO13485',
    'about.qualificationRohs': 'ROHS认证',
    'about.qualificationSgs': 'SGS认证',
    'about.qualificationCe': 'CE认证',
    'about.qualificationClassII': '二类医疗器械认证',
    'about.qualificationHighTech': '高新技术企业',
    'about.documentTitle': '关于ANOVATOR',
    'contact.title': '联系我们',
    'contact.intro': '如需了解更多关于我们的信息，请通过以下方式联系我们，我们将竭诚为您服务。',
    'contact.headOffice': '全球总部',
    'contact.phone': '电话:',
    'contact.email': '邮箱:',
    'contact.namePlaceholder': '输入您的姓名',
    'contact.emailPlaceholder': '输入您的电子邮箱',
    'contact.phonePlaceholder': '输入您的手机号',
    'contact.messagePlaceholder': '在此输入您的留言',
    'contact.submit': '提交',
    'contact.submitting': '提交中...',
    'contact.closeAria': '关闭联系我们',
    'contact.privacyPrefix': '我已阅读并接受',
    'contact.privacyLink': '隐私政策',
    'contact.privacySuffix': '。',
    'contact.nameRequired': '请输入您的姓名。',
    'contact.emailRequired': '请输入您的电子邮箱。',
    'contact.emailInvalid': '请输入有效的电子邮箱地址。',
    'contact.whatsappRequired': '请输入您的手机号。',
    'contact.whatsappShort': '手机号至少需要6个字符。',
    'contact.whatsappInvalid': '手机号格式无效。',
    'contact.messageRequired': '请输入您的留言。',
    'contact.privacyRequired': '请确认您已阅读并接受隐私政策。',
    'home.learnMore': '了解更多',
    'home.technologyBefore': '',
    'home.technologyAfter': '如何评估人们的健康',
    'home.technologyParagraph1': '我们采用多频8点触觉电极系统，每只手和每只脚上各放置两个电极。测量过程中，电极分别检测来自五个身体部位的阻抗数据：左臂、右臂、躯干、左腿和右腿。',
    'home.technologyParagraph2': '与传统的生物电阻抗分析（BIA）测量相比，我们采用的多频交流电能够更好地穿透人体细胞，并具有更强的抗外部电磁干扰能力。这使我们能够获得更精确的人体成分测量结果。',
    'home.technologyParagraph3': '我们利用人工智能图像分析技术来确定骨骼点的精确位置和尺寸，并结合准确的身体成分数据，例如身体各部位的肌肉和脂肪含量。这使我们能够精确分析体态风险和身体围度测量数据。',
    'home.exhibitionTitle': '展会日程',
    'home.exhibitionLead': '我们期待在展会现场与您见面！',
    'home.highlightsAria': 'ANOVATOR 精选内容',
    'home.industriesAria': '行业',
    'home.featuredStoriesAria': '精选资讯',
    'home.previousStory': '上一条资讯',
    'home.nextStory': '下一条资讯',
    'home.goToSlide': '转到第 {{index}} 张',
    'footer.homeAria': 'ANOVATOR 首页',
    'footer.contactAria': '联系 ANOVATOR',
    'footer.socialAria': 'ANOVATOR 社交媒体',
    'footer.legalAria': '法律链接',
    'support.title': 'ANOVATOR 技术支持',
    'support.lead': '如需协助？从这里开始',
    'support.selectDevice': '请选择您的设备',
    'support.faq': '常见问题',
    'support.brochure': '产品手册',
    'support.manual': '使用手册',
    'support.tutorials': '教程',
    'support.deviceSeries': '设备系列',
    'support.productDocuments': '产品文档',
    'support.tutorialsAria': '教程',
    'support.tutorialControls': '教程轮播控制',
    'support.previousTutorials': '上一条教程',
    'support.nextTutorials': '下一条教程',
    'support.faqCategories': '常见问题分类',
    'news.latest': '最新资讯',
    'news.more': '更多资讯',
    'news.viewMore': '查看更多',
    'news.newsroom': '新闻中心',
    'news.all': '全部新闻',
    'news.loading': '正在加载新闻...',
    'news.loadingLatest': '正在加载最新资讯...',
    'news.loadingMore': '正在加载更多资讯...',
    'news.latestUnavailable': '最新资讯暂不可用',
    'news.moreUnavailable': '更多资讯暂不可用',
    'news.loadingFailed': '加载失败',
    'news.noTop': '暂无置顶新闻。',
    'news.noMore': '暂无更多新闻。',
    'news.noContent': '暂无内容',
    'news.noArticlesInCategory': '该分类下暂无新闻。',
    'news.reload': '重新加载',
    'news.filterLabel': '按分类筛选新闻',
    'news.allCategories': '全部',
    'news.pagination': '新闻分页',
    'news.previousPage': '上一页',
    'news.nextPage': '下一页',
    'news.goToPage': '前往第',
    'news.readArticle': '阅读',
    'news.socialLinks': '新闻社交链接',
    'news.backToList': '返回新闻列表',
    'news.notFound': '未找到新闻',
    'news.notFoundDescription': '您查找的新闻可能已被删除或不存在。',
    'news.fallbackAuthor': 'ANOVATOR 团队',
    'news.networkTopError': '网络连接失败，无法获取置顶新闻。',
    'news.networkMoreError': '网络连接失败，无法获取更多资讯。',
    'news.networkError': '网络连接失败，无法获取新闻。请检查网络连接后重试。',
    'news.invalidUrl': '无效的新闻链接',
    'news.detailNetworkError': '网络连接失败，请稍后重试。',
    'actions.continueReading': '继续阅读',
    'actions.industryLearnMore': '了解更多',
    'industries.scenarios': '适用场景',
    'industryDetail.recommendations': '产品推荐',
    'industryDetail.loading': '正在加载行业详情...',
    'industryDetail.loadError': '暂时无法加载行业详情，请重试。',
    'industryDetail.retry': '重试',
    'industryDetail.notFound': '未找到行业场景',
    'industryDetail.returnToIndustry': '返回行业页面',
    'exhibition.ended': '已结束',
    'exhibition.ongoing': '进行中',
    'exhibition.upcoming': '即将开始',
    'exhibition.carouselControls': '展会轮播控件',
    'exhibition.previousSlide': '上一场展会',
    'exhibition.nextSlide': '下一场展会',
    'exhibition.venueSuffix': '展会现场'
  })
})

function readSupportedLanguage(value) {
  const normalized = String(value || '').trim().toUpperCase()
  return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : null
}

function normalizeLanguage(value) {
  return readSupportedLanguage(value) || DEFAULT_LANGUAGE
}

function browserStorage() {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage
  } catch (_) {
    return null
  }
}

function createSiteLanguage(storage = browserStorage()) {
  let storedLanguage = null
  try {
    storedLanguage = storage && storage.getItem(LANGUAGE_STORAGE_KEY)
  } catch (_) {
    storedLanguage = null
  }

  const state = reactive({ currentLanguage: normalizeLanguage(storedLanguage) })
  let initializationRequest = null

  function getStoredLanguage() {
    try {
      return readSupportedLanguage(storage && storage.getItem(LANGUAGE_STORAGE_KEY))
    } catch (_) {
      return null
    }
  }

  function setLanguage(language) {
    const normalized = normalizeLanguage(language)
    state.currentLanguage = normalized
    try {
      if (storage) storage.setItem(LANGUAGE_STORAGE_KEY, normalized)
    } catch (_) {
      // Keep the in-memory language usable when storage is unavailable.
    }
  }

  async function initializeDefaultLanguage(loadDefaultLanguage) {
    const stored = getStoredLanguage()
    if (stored) {
      state.currentLanguage = stored
      return stored
    }
    if (initializationRequest) return initializationRequest

    initializationRequest = Promise.resolve()
      .then(() => loadDefaultLanguage())
      .then((language) => {
        const resolved = readSupportedLanguage(language)
        if (!resolved) throw new Error('Invalid default site language')
        if (getStoredLanguage()) return state.currentLanguage
        setLanguage(resolved)
        return resolved
      })
      .catch(() => {
        state.currentLanguage = DEFAULT_LANGUAGE
        return DEFAULT_LANGUAGE
      })
      .finally(() => {
        initializationRequest = null
      })

    return initializationRequest
  }

  function t(key) {
    return MESSAGES[state.currentLanguage]?.[key] ?? MESSAGES.EN[key] ?? key
  }

  return { state, setLanguage, initializeDefaultLanguage, t }
}

const siteLanguage = createSiteLanguage()

function initializeSiteLanguage() {
  return siteLanguage.initializeDefaultLanguage(() => {
    const { siteLanguageAPI } = require('./api.js')
    return siteLanguageAPI.getDefault().then(result => result && result.siteType)
  })
}

const siteLanguageMixin = {
  computed: {
    currentLanguage() {
      return siteLanguage.state.currentLanguage
    }
  },
  methods: {
    t: siteLanguage.t
  }
}

module.exports = {
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
  MESSAGES,
  createSiteLanguage,
  siteLanguage: siteLanguage.state,
  setLanguage: siteLanguage.setLanguage,
  initializeSiteLanguage,
  t: siteLanguage.t,
  siteLanguageMixin
}
